import React from 'react'

import { Icon, IconProps } from '@chakra-ui/react'

export const MagicStarsIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M12.9926 11.1124L9.00737 10.0002C8.77567 9.93068 8.59031 9.74532 8.5208 9.51362L7.40864 5.52836C7.22328 4.85643 6.25013 4.85643 6.06477 5.52836L4.95261 9.51362C4.8831 9.74532 4.69774 9.93068 4.46603 10.0002L0.50395 11.1124C-0.167983 11.2977 -0.167983 12.2709 0.50395 12.4562L4.48921 13.5684C4.72091 13.6379 4.90627 13.8233 4.97578 14.055L6.08794 18.0402C6.2733 18.7121 7.24645 18.7121 7.43181 18.0402L8.54397 14.055C8.61348 13.8233 8.79884 13.6379 9.03054 13.5684L13.0158 12.4562C13.6646 12.2477 13.6646 11.2977 12.9926 11.1124Z"
        fill="currentColor"
      />
      <path
        d="M11.0926 5.20444L13.595 5.89954C13.734 5.94588 13.8499 6.06173 13.8962 6.20075L14.6145 8.70312C14.7303 9.14335 15.3328 9.14335 15.4718 8.70312L16.19 6.20075C16.2364 6.06173 16.3522 5.94588 16.4913 5.89954L18.9936 5.20444C19.4339 5.08859 19.4339 4.48617 18.9936 4.34714L16.4681 3.62887C16.3291 3.58253 16.2132 3.46668 16.1669 3.32766L15.4718 0.825291C15.3559 0.385059 14.7535 0.385059 14.6145 0.825291L13.8962 3.32766C13.8499 3.46668 13.734 3.58253 13.595 3.62887L11.0926 4.34714C10.6524 4.463 10.6524 5.06542 11.0926 5.20444Z"
        fill="currentColor"
      />
      <path
        d="M21.6351 15.9325L18.6461 15.0984C18.4608 15.0521 18.3449 14.9131 18.2754 14.7277L17.4413 11.7388C17.3023 11.229 16.584 11.229 16.445 11.7388L15.6109 14.7277C15.5645 14.9131 15.4255 15.0289 15.2401 15.0984L12.2512 15.9325C11.7415 16.0716 11.7415 16.7898 12.2512 16.9289L15.2401 17.763C15.4255 17.8093 15.5414 17.9483 15.6109 18.1337L16.445 21.1226C16.584 21.6324 17.3023 21.6324 17.4413 21.1226L18.2754 18.1337C18.3218 17.9483 18.4608 17.8093 18.6461 17.763L21.6351 16.9289C22.1217 16.7898 22.1217 16.0716 21.6351 15.9325Z"
        fill="currentColor"
      />
    </Icon>
  )
}
